import { ContractInsuredPeopleInterface } from '../../../../interfaces/request/contracts/contract-insured-people/contract-insured-people-interface';

export class ContractInsuredPeopleModel implements ContractInsuredPeopleInterface {
  commercialPremium: string = '';
  endDatePolicy: string = '';
  personBirthdate: string = '';
  personCardNumber: string = '';
  personId: string = '';
  personName: string = '';
  personNif: string = '';
  policyNumber: string = '';
  startDatePolicy: string = '';
  totalPremium: string = '';
  extraBtn?: boolean = false;

  constructor(init?: Partial<ContractInsuredPeopleModel>) {
    Object.assign(this, init);
  }
}
